/**
 * Seller Portal -> Seller Audit Logs API — wraps /api/seller/audit-logs/*
 * (Phase 8). Read-only view over the SellerAuditLog table every prior
 * Seller Portal phase already writes to — see
 * backend/app/services/seller/seller_audit_service.py. Nothing here is
 * mocked; no new events are generated by this page, it only reads.
 */
import apiClient from '../apiClient.js';

function cleanParams(params = {}) {
  return Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== '' && v !== 'All')
  );
}

export const sellerAuditLogApi = {
  getStats: () => apiClient.get('/seller/audit-logs/stats').then((r) => r.data),

  /** params: { q, seller_user, customer, action, module, date_from, date_to, page, page_size } */
  list: (params = {}) => apiClient.get('/seller/audit-logs', { params: cleanParams(params) }).then((r) => r.data),

  get: (id) => apiClient.get(`/seller/audit-logs/${id}`).then((r) => r.data),

  /** Downloads a CSV or Excel export of the (optionally filtered) audit trail. Returns a Blob. */
  export: (format, params = {}) =>
    apiClient
      .get('/seller/audit-logs/export', { params: cleanParams({ ...params, format }), responseType: 'blob' })
      .then((r) => r.data),
};
